import { jsx as t, Fragment as o } from "react/jsx-runtime";
const a = () => /* @__PURE__ */ t(o, {});
export {
  a as default
};
//# sourceMappingURL=DefaultComponent.js.map
